var map = {
	"./bg-sidebar-desktop.svg": 7053,
	"./bg-sidebar-mobile.svg": 4330,
	"./favicon-32x32.png": 5024,
	"./icon-advanced.svg": 4100,
	"./icon-arcade.svg": 2775,
	"./icon-checkmark.svg": 2691,
	"./icon-pro.svg": 7037,
	"./icon-thank-you.svg": 889,
	"./logo.png": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;